// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"938f1c62","419":"d7212ef2","439":"0ed8655c","458":"3e8873a5","512":"f41d25e5","774":"36a46efa","787":"93cae69c","858":"2173b9c9"}[chunkId] + ".chunk.js";
};